import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input
} from '@angular/core'
import { hlm } from '@spartan-ng/helm/utils'
import type { ClassValue } from 'clsx'

@Component({
  selector: 'hlm-sheet-footer',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': '_computedClass()'
  },
  template: ` <ng-content /> `
})
export class HlmSheetFooter {
  public readonly userClass = input<ClassValue>('', { alias: 'class' })
  protected readonly _computedClass = computed(() =>
    hlm('mt-auto flex flex-col gap-2 p-4', this.userClass())
  )
}
